import React from 'react';
import { ScarcityBanner } from '../components/ScarcityBanner';
import { HeroLP5 } from '../components/HeroLP5';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolutionLP4 } from '../components/ProblemSolutionLP4';
import { ValueStackLP4 } from '../components/ValueStackLP4';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { ClosingLP4 } from '../components/ClosingLP4';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPageLP5() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1345">
      <ScarcityBanner data-id="element-1346" />
      <HeroLP5 data-id="element-1347" />
      <Testimonial data-id="element-1348" />
      <ProblemSolutionLP4 data-id="element-1349" />
      <ValueStackLP4 data-id="element-1350" />
      <ModuleBreakdown data-id="element-1351" />
      <Guarantee data-id="element-1352" />
      <ClosingLP4 data-id="element-1353" />
      <Footer data-id="element-1354" />
      <RecentPurchaseToast data-id="element-1355" />
    </div>;
}